import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import TestEmailServerModal from "pages/AllCommonModal/TestEmailServerModal/test-email-server-modal";

const TestEmailServer = () => {
  const [testEmailServerModalOpen, setTestEmailServerModalOpen] = useState(false);

  useEffect(() => {
    setTestEmailServerModalOpen(true);
  }, []);

  return (
    <div className="page-content">
      <Container fluid />
      <TestEmailServerModal
        testEmailServerModalOpen={testEmailServerModalOpen}
        setTestEmailServerModalOpen={setTestEmailServerModalOpen}
      />
    </div>
  );
};

export default TestEmailServer;
